module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/quizzes-table/quizzes-table.component.css
// module id = ./src/app/quizzes-table/quizzes-table.component.css
// module chunks = main